// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-80e4b9c6]{position:relative}p span[data-v-80e4b9c6],p[data-v-80e4b9c6]{color:#5a5a5a !important}p span[data-v-80e4b9c6]{text-decoration:underline}img[data-v-80e4b9c6]{width:200px;height:120px;position:absolute;right:30px;bottom:0;display:none}@media only screen and (max-width: 959px){img[data-v-80e4b9c6]{position:relative;right:auto}}", ""]);
// Exports
module.exports = exports;
